import React from 'react';
import { ThemeProvider } from 'styled-components';
import { Link } from 'gatsby';
import OImage from '../OImage';

import { Module, Top, Container, Card } from './styles';
import Wrapper from '../../ui/Wrappers';
import { themes } from '../../ui/design-tokens';
import { ButtonSmall } from '../../ui/Button';
import { getSrcset, externalLink } from '../../ui/helpers';

interface ICard {
  key?: string;
  theme?: string;
  title?: string;
  text?: string;
  link: any;
  imageUrl: any;
  imageAlt: string;
}

interface IProps {
  theme?: string;
  heading: string;
  title?: string;
  cards: Array<ICard>;
}

const Distributor = ({ theme, heading, title, cards }: IProps) => {
  const cleanedTheme = theme ? theme : 'white';
  const isGradient = cleanedTheme.endsWith('_gradient');
  return (
    <ThemeProvider theme={themes[isGradient ? 'gradients' : 'billboard'][cleanedTheme]}>
      <Module gradient={isGradient}>
        <Wrapper as={Top} size="reader">
          {title &&
            (heading === 'heading_2' ? (
              <h2 className="title">{title}</h2>
            ) : (
              <h3 className="title">{title}</h3>
            ))}
        </Wrapper>
        <Wrapper size="mainwrapper" as={Container}>
          {cards.map((card, index) => {
            let cleanedTheme = card.theme ? card.theme : 'white';
            let isGradient = cleanedTheme.endsWith('_gradient');
            return (
              <ThemeProvider key={card.key} theme={themes[isGradient ? 'gradients' : 'basic'][cleanedTheme]}>
                <Card
                  key={card.key}
                  data-gtm-action={`distributor_${card?.title}`}
                  data-gtm-category="cta">
                  <div className="textZone">
                    {card.title && <div className="textZone_title">{card.title}</div>}
                    {card.text && <p className="textZone_text">{card.text}</p>}
                    {card.link && card.link?.uri && (
                      <div className="btnWrapper">
                        <ButtonSmall
                          as={externalLink(card.link.uri) ? 'a' : Link}
                          className="btn"
                          href={externalLink(card.link.uri) ? card.link.uri : null}
                          to={externalLink(card.link.title) ? null : card.link.uri}
                          target={externalLink(card.link.uri) ? '_blank' : null}
                          rel={externalLink(card.link.uri) ? 'nofollow noopener noreferrer' : null}
                          secondary={1}
                          data-gtm-event
                          data-gtm-label={`${card.link?.title}_${
                            typeof window !== 'undefined' ? window.location.href : ''
                          }`}>
                          {card.link.title}
                        </ButtonSmall>
                      </div>
                    )}
                  </div>
                  <div className="imageZone">
                    {card.imageUrl && (
                      <OImage
                        src={card.imageUrl.original?.href}
                        aspectRatio={
                          card.imageUrl.original?.meta.width / card.imageUrl.original?.meta.height
                        }
                        alt={card.imageAlt || ''}
                        srcSet={getSrcset(card.imageUrl)}
                        webp={getSrcset(card.imageUrl, true)}
                        className="imageZone_image"
                      />
                    )}
                  </div>
                </Card>
              </ThemeProvider>
            );
          })}
        </Wrapper>
      </Module>
    </ThemeProvider>
  );
};

export default Distributor;
